"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper as SwiperType } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

interface DynamicSwiperProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  slidesPerView?: number;
  spaceBetween?: number;
  autoplay?: boolean;
  pagination?: boolean;
  navigation?: boolean;
  breakpoints?: Record<number, Record<string, unknown>>;
  onSwiper?: (swiper: SwiperType) => void;
  className?: string;
}

function DynamicSwiper<T>({
  items,
  renderItem,
  slidesPerView = 6,
  spaceBetween = 5,
  autoplay = false,
  navigation = false,
  breakpoints,
  onSwiper,
  className,
}: DynamicSwiperProps<T>) {
  return (
    <Swiper
      modules={[...(autoplay ? [Autoplay] : []), Navigation, Pagination]}
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      autoplay={autoplay ? { delay: 2500, disableOnInteraction: true } : false}
      loop={false}
      freeMode={false}
      navigation={navigation}
      pagination={false}
      breakpoints={breakpoints}
      onSwiper={onSwiper}
      observer={true}
      className={`relative
  [&_.swiper-button-prev]:!absolute [&_.swiper-button-next]:!absolute
  [&_.swiper-button-prev]:!flex [&_.swiper-button-next]:!flex
  [&_.swiper-button-prev]:!items-center [&_.swiper-button-next]:!items-center
  [&_.swiper-button-prev]:!justify-center [&_.swiper-button-next]:!justify-center
  [&_.swiper-button-prev]:!w-8 [&_.swiper-button-next]:!w-8
  [&_.swiper-button-prev]:!h-8 [&_.swiper-button-next]:!h-8
  [&_.swiper-button-prev]:!rounded-full [&_.swiper-button-next]:!rounded-full
  [&_.swiper-button-prev]:!bg-white [&_.swiper-button-next]:!bg-white
  [&_.swiper-button-prev]:!text-black [&_.swiper-button-next]:!text-black
  [&_.swiper-button-prev]:!opacity-80 [&_.swiper-button-next]:!opacity-80
  [&_.swiper-button-prev:hover]:!opacity-100 [&_.swiper-button-next:hover]:!opacity-100
  [&_.swiper-button-prev]:!top-1/2 [&_.swiper-button-next]:!top-1/2
  [&_.swiper-button-prev]:!left-2 [&_.swiper-button-next]:!right-2
  [&_.swiper-button-prev]:!-translate-y-1/2 [&_.swiper-button-next]:!-translate-y-1/2
  [&_.swiper-button-prev::after]:!text-xs [&_.swiper-button-next::after]:!text-xs
  [&_.swiper-button-prev::after]:!leading-none [&_.swiper-button-next::after]:!leading-none
  [&_.swiper-button-prev]:!z-20 [&_.swiper-button-next]:!z-20
  ${className ?? ""}`}
    >
      {items.map((item, index) => (
        <SwiperSlide key={index}>{renderItem(item, index)}</SwiperSlide>
      ))}
    </Swiper>
  );
}

export default DynamicSwiper;
